import React, { Fragment, useEffect } from "react";
import HeadSection from "../components/home/HeadSection";
import MainSection from "../components/home/MainSection";
import SecondSection from "../components/home/SecondSection";
import Footer from "../components/footer/Footer";
import { Box } from "@material-ui/core";

export default function Home({ setTab }) {
  useEffect(() => setTab("Home"), [setTab]);
  return (
    <Fragment>
      <HeadSection />
      <Box style={{alignContent: "center"}}>        
        <MainSection />
        <SecondSection />
        <Footer />
      </Box>
    </Fragment>
  );
}
